import { useEffect } from "react";
import { useBlocker } from "react-router";
import { hasUnsavedChanges, leavesWithoutPrompt, useHasUnsavedChanges } from "@/shared/hooks/useUnsavedChanges";
import { ConfirmDialog } from "@/shared/ui";

/**
 * One guard for the whole app (a router allows a single blocker): while any
 * form registered with useUnsavedChanges is dirty, moving to another page asks
 * first, and closing or reloading the tab triggers the browser's own prompt.
 */
export function UnsavedChangesPrompt() {
  const dirty = useHasUnsavedChanges();
  // Read the registry at navigation time; query-string changes (filters, tabs) stay free.
  const blocker = useBlocker(({ currentLocation, nextLocation }) => {
    const skip = leavesWithoutPrompt(nextLocation.state);
    return skip !== "all" && hasUnsavedChanges(skip === "modal") && currentLocation.pathname !== nextLocation.pathname;
  });

  useEffect(() => {
    if (!dirty) return;
    const onBeforeUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = ""; // older browsers only show the prompt with this set
    };
    window.addEventListener("beforeunload", onBeforeUnload);
    return () => window.removeEventListener("beforeunload", onBeforeUnload);
  }, [dirty]);

  if (blocker.state !== "blocked") return null;
  return (
    <ConfirmDialog title="Rời trang khi chưa lưu?" confirmLabel="Rời trang" cancelLabel="Ở lại"
      onConfirm={() => blocker.proceed()} onClose={() => blocker.reset()}>
      <p>Bạn có thay đổi chưa lưu. Rời trang này thì các thay đổi đó sẽ mất.</p>
    </ConfirmDialog>
  );
}
